import Vue from 'vue'
import pcHeader from './pcHeader'
import footGuide from './footGuide'
import clientService from './clientService'
import vkDialog from './vkDialog'
import VkAlert from './vkAlert/index.js'
import vkBtn from './vkBtn'

Vue.component('pcHeader', pcHeader)
Vue.component('footGuide', footGuide)
Vue.component('clientService', clientService)
Vue.component('vkDialog', vkDialog)
Vue.component('vkBtn', vkBtn)
Vue.use(VkAlert)